import React from "react";
import image2 from "../../assets/Ropeway.png";
import image3 from "../../assets/Eco-friendly.png";

import image4 from "../../assets/revolutionary.png";
import image5 from "../../assets/Covid19.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const AboutMyWork = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
  }, []);
  return (
    <>
      <div className="w-full flex flex-col gap-10 items-center justify-between lg:px-20 md:px-10 px-8 lg:mt-10 ">
        <div className="w-full">
          <div className="flex w-full items-center justify-between relative lg:flex-row flex-col">
            <div
              className="bg-white lg:shadow-lg rounded w-full md:w-auto xl:w-[40%] lg:w-[70%] lg:px-10 xl:p-8 z-10 lg:absolute top-20 md:top-auto right-0  lg:mt-0"
              data-aos="fade-down-left"
            >
              <h3 className="capitalize text-2xl font-bold">
                Ropeway Projects
              </h3>
              <p className="text-md text-justify leading-normal tracking-normal mt-2">
                He pioneered Odisha's first low-cost ropeway project at Jahwar
                Minar, Hirakud, through customized designs, technical audits,
                and quality control measures. His consultancy extended beyond
                installation, ensuring seamless operation during the 3-year
                warranty period, earning accolades for his dedication and
                expertise.
              </p>
            </div>
            <img
              src={image2}
              alt="Evaluate Image"
              className="lg:w-[65%] z-0 w-full mt-5 lg:mt-0"
              data-aos="fade-down-right"
            />
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-10 items-center justify-between lg:px-20 md:px-10 px-8 lg:mt-10 mt-5">
        <div className="w-full">
          <div className="flex w-full items-center justify-between relative lg:flex-row flex-col">
            <div
              className="bg-white lg:shadow-lg rounded w-full md:w-auto xl:w-[40%] lg:w-[70%] lg:px-10 xl:p-8 z-10 lg:absolute top-20 md:top-auto left-0 "
              data-aos="fade-down-right"
            >
              <h3 className="capitalize text-2xl font-bold">
                Eco-Friendly Cremation Technology
              </h3>
              <p className="text-md text-justify leading-normal tracking-normal mt-2">
                Sailesh Dani introduced advanced human cremation technologies in
                electric and gas-fired crematoriums, aligning with the latest
                Ministry of Environment, Forest and Climate Change (MOEF)
                guidelines, setting a benchmark in sustainable and efficient
                cremation systems.
              </p>
            </div>

            <img
              src={image3}
              alt="Ropeway Image"
              className="lg:w-[65%] z-0 w-full ml-auto mt-5 sm:mt-0"
              data-aos="fade-down-left"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col gap-10 items-center justify-between lg:px-20 md:px-10 px-8 lg:mt-10 mt-5">
        <div className="w-full">
          <div className="flex w-full items-center justify-between relative lg:flex-row flex-col">
            <div
              className="bg-white lg:shadow-lg rounded w-full md:w-auto xl:w-[45%] lg:w-[70%] lg:px-10 xl:p-4 z-10 lg:absolute top-20 md:top-auto right-0"
              data-aos="fade-down-left"
            >
              <h3 className="capitalize text-2xl font-bold">
                Revolutionary Education Initiatives
              </h3>
              <p className="text-md text-justify leading-normal tracking-normal mt-2">
                As a visionary in education, he developed the first-of-its-kind
                Virtual Skill Lab for regional school students. This initiative
                revolutionized learning by introducing ICSE & CBSE-aligned
                subjects such as Pharmacology, Regional Anatomy, Surface
                Anatomy, Physics, Chemistry, Biology, and Mathematics for
                Classes VIII to XII. His innovative approach empowered regional
                students to compete on a national level, fostering a generation
                of well-educated and confident individuals.
              </p>
            </div>
            <img
              src={image4}
              alt="Evaluate Image"
              className="lg:w-[65%] z-0 w-full mt-5 lg:mt-0"
              data-aos="fade-down-right"
            />
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-10 items-center justify-between lg:px-20 md:px-10 px-8 lg:mt-10 mt-5">
        <div className="w-full">
          <div className="flex w-full items-center justify-between relative lg:flex-row flex-col">
            <div
              className="bg-white lg:shadow-lg rounded w-full md:w-auto xl:w-[55%] lg:w-[70%]  lg:px-10 xl:p-8 z-10 lg:absolute top-20 md:top-auto left-0 "
              data-aos="fade-down-right"
            >
              <h3 className="capitalize text-2xl font-bold">
                Covid - 19 Pandemic
              </h3>
              <p className="text-md text-justify  tracking-normal mt-1">
                Sailesh Dani, a dedicated professional, extended his support
                during the COVID-19 pandemic by contributing essential medical
                resources to aid healthcare facilities and frontline workers. As
                a gesture of gratitude, he generously donated two ventilators to
                the District Headquarters Hospital, Sambalpur, ensuring critical
                care for patients in need. Additionally, he distributed 10,000
                masks across various districts, reinforcing public health &
                safety during a challenging time. His selfless contributions
                exemplify his commitment to social responsibility and
                community welfare.
              </p>
            </div>

            <img
              src={image5}
              alt="Ropeway Image"
              className="lg:w-[65%] z-0 w-full ml-auto mt-5 sm:mt-0"
              data-aos="fade-down-left"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMyWork;
